import { useEffect, useState } from "react";
import axios from "axios";
import {
  Wifi,
  WifiOff,
} from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const [namaToko, setNamaToko] =
    useState("Dashboard");

  const [namaUser, setNamaUser] =
    useState("A");

  const [isOnline, setIsOnline] =
    useState(navigator.onLine);

  const [connectionType, setConnectionType] =
    useState("Checking...");

  useEffect(() => {
    const toko =
      localStorage.getItem("nama_toko");

    if (toko) {
      setNamaToko(toko);
    }

    const nama =
      localStorage.getItem("nama");

    if (nama) {
      setNamaUser(nama);
    }

    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    const updateConnection = () => {
      if (navigator.connection) {
        setConnectionType(
          navigator.connection.effectiveType
        );
      } else {
        setConnectionType("Unknown");
      }
    };

    updateConnection();

    window.addEventListener(
      "online",
      updateOnlineStatus
    );

    window.addEventListener(
      "offline",
      updateOnlineStatus
    );

    navigator.connection?.addEventListener(
      "change",
      updateConnection
    );

    return () => {
      window.removeEventListener(
        "online",
        updateOnlineStatus
      );

      window.removeEventListener(
        "offline",
        updateOnlineStatus
      );

      navigator.connection?.removeEventListener(
        "change",
        updateConnection
      );
    };
  }, []);

const logout = async () => {
  try {
    // 1. Local Storage
    localStorage.clear();

    // 2. Session Storage
    sessionStorage.clear();

    // 3. Cookies
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name +
        "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });

    // 4. IndexedDB (hapus semua database)
    if (window.indexedDB && indexedDB.databases) {
      const dbs = await indexedDB.databases();
      dbs.forEach((db) => {
        if (db.name) indexedDB.deleteDatabase(db.name);
      });
    }

    // fallback kalau databases() tidak support
    else if (window.indexedDB) {
      // kalau kamu tahu nama DB manual:
      // indexedDB.deleteDatabase("your-db-name");
    }

    // 5. Cache Storage (Service Worker cache)
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map((name) => caches.delete(name))
      );
    }

    // 6. Optional: remove axios token default header
    delete axios.defaults.headers.common["Authorization"];

    // 7. Redirect (hard reset)
    window.location.replace("/login");
  } catch (err) {
    console.log("Logout reset error:", err.message);

    // tetap paksa logout
    window.location.replace("/login");
  }
};

  return (
    <div className="h-16 bg-white/80 backdrop-blur-xl border-b border-gray-100 flex items-center justify-between px-3 md:px-6 shrink-0 sticky top-0 z-50">

      {/* LEFT DESKTOP ONLY */}
      <div className="hidden md:flex items-center gap-4">

        {/* STORE NAME */}
        <div>
          <h2 className="font-semibold text-gray-800 text-lg">
            {namaToko}
          </h2>

          <p className="text-xs text-gray-400">
            Dashboard Analytics
          </p>
        </div>

        {/* NETWORK STATUS */}
        <div
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition ${
            isOnline
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {isOnline ? (
            <>
              <Wifi size={15} />
              <span>
                Online • {connectionType}
              </span>
            </>
          ) : (
            <>
              <WifiOff size={15} />
              <span>Offline</span>
            </>
          )}
        </div>

      </div>

      {/* MOBILE TITLE */}
      <div className="md:hidden">
       
      </div>

      {/* PROFILE */}
      <div className="relative ml-auto">

        {/* AVATAR */}
        <button
          onClick={() => setOpen(!open)}
          className="w-11 h-11 rounded-full bg-gradient-to-br from-indigo-500 via-blue-500 to-cyan-500 text-white font-bold flex items-center justify-center shadow-lg active:scale-95 transition-all duration-200"
        >
          {namaUser.charAt(0).toUpperCase()}
        </button>

        {/* DROPDOWN */}
        {open && (
          <>
            {/* BACKDROP */}
            <div
              className="fixed inset-0 z-40"
              onClick={() => setOpen(false)}
            />

            {/* MENU */}
            <div className="absolute right-0 mt-3 w-56 bg-white border border-gray-100 shadow-2xl rounded-2xl overflow-hidden z-50 animate-in fade-in zoom-in-95 duration-200">

              {/* HEADER */}
              <div className="px-4 py-4 border-b bg-gradient-to-r from-indigo-50 to-blue-50">

                <div className="flex items-center gap-3">

                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-blue-500 text-white flex items-center justify-center font-bold text-lg shadow">
                    {namaUser.charAt(0).toUpperCase()}
                  </div>

                  <div>
                    <p className="text-sm font-semibold text-gray-800">
                      {namaUser}
                    </p>

                    <p className="text-xs text-gray-500">
                      Active Account
                    </p>
                  </div>

                </div>

              </div>

              {/* MENU ITEMS */}
              <button
                className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition"
              >
                Profile
              </button>

              <button
                className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition"
              >
                Settings
              </button>

              <button
                onClick={logout}
                className="w-full text-left px-4 py-3 text-sm text-red-500 hover:bg-red-50 transition"
              >
                Logout
              </button>

            </div>
          </>
        )}

      </div>

    </div>
  );
}